import styled from 'styled-components';

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  background-color: ${props => props.theme.color.backgroundRush};
  border-radius: 20px;
  margin-bottom: 10px;
`;

export const Styled = {
  Container,
};
